<template>
  <q-dialog
    v-model="open"
    no-backdrop-dismiss
    no-esc-dismiss
    no-route-dismiss
    maximized
  >
    <div class="system-dialog">
      <q-card class="q-py-xl q-px-md">
        <template v-if="state === 'check'">
          <q-circular-progress
            show-value
            indeterminate
            font-size="16px"
            size="250px"
            color="blue-7"
            track-color="white"
            :thickness="0.05"
          >
            <div class="q-px-lg q-py-md">
              <mira-icon />
              <div class="text-bold q-pt-md">
                Checking App Version
              </div>
            </div>
          </q-circular-progress>
        </template>

        <template v-else-if="state === 'outdated'">
          <mira-logo
            width="125px"
            height="32px"
            type="horizontal"
            class="q-mb-xl"
          />

          <q-item-label class="text-h4 sys-title q-pb-md">
            <template v-if="$q.platform.is.nativeMobile">
              Update App
            </template>
            <template v-else>
              Update Available
            </template>
          </q-item-label>

          <q-item-label class="sys-descr text-h6 q-pb-sm text-bold">
            Your version of {{ siteName }} is out of date.
          </q-item-label>

          <q-item-label v-if="$q.platform.is.nativeMobile" class="sys-descr text-h6 q-pb-sm">
            Please update the app through the {{ appStore }}.
          </q-item-label>

          <q-item-label class="sys-descr text-h6">
            <template v-if="$q.platform.is.nativeMobile">
              If an update is not yet visible through the {{ appStore }}, you may access {{ siteName }} via our website directly.
            </template>
            <template v-else>
              You must refresh the page to load the new version.
            </template>
          </q-item-label>

          <q-separator dark />

          <div class="q-mt-xl flex justify-center">
            <q-btn
              v-if="$q.platform.is.nativeMobile"
              flat
              no-caps
              label="Open Website"
              @click="goToHref(appUrl, true)"
            />
            <q-btn
              v-else
              label="Refresh Page"
              no-caps
              icon-right="mdi-refresh"
              :color="!appStoreLink ? 'blue-7' : undefined"
              :flat="!!appStoreLink"
              @click="reloadPage"
            />

            <q-btn
              v-if="appStoreLink"
              no-caps
              label="Open Store"
              color="blue-7"
              icon-right="mdi-chevron-right"
              @click="goToStore"
            />
          </div>
        </template>
      </q-card>
    </div>
  </q-dialog>
</template>

<script>
import pkg from '../../../../package.json'
import semver from 'semver'
import { generateBusinessUrl } from 'src/router'

/**
 * Prompt that an update is available
 * On Capacitor, check first if a new version is available from the App Stores
 */
export default {
  emits: ['ready'],
  data () {
    return {
      state: 'check',
      open: true,
      appUrl: generateBusinessUrl(),
      appIds: process.env.APP_IDS
    }
  },
  computed: {
    appStore () {
      const platform = this.$q.platform.is
      if (platform.android) {
        return 'Google Play Store'
      }
      return 'App Store'
    },
    appStoreLink () {
      const platform = this.$q.platform.is

      if (platform.android) {
        return 'market://details?id=' + this.appIds.android
      }
      else if (platform.ios) {
        return 'itms-apps://itunes.apple.com/app/id' + this.appIds.ios
      }
      return null
    }
  },
  methods: {
    async checkAppVersion () {
      const { status, payload } = await this.$get('v1/system/checkAppVersion')
      if (status === 'success') {
        const version = payload.version
        if (!version || pkg.version === version || semver.gt(pkg.version, version)) {
          this.updatesFinished()
        }
        else {
          this.state = 'outdated'
        }
      }
    },
    updatesFinished () {
      this.open = false
      this.$emit('ready')
    },
    goToStore () {
      this.goToHref(this.appStoreLink, true, true)
    },
    reloadPage () {
      window.location.reload()
    },
    busOnVersionRefresh () {
      this.state = 'outdated'
      this.open = true
    }
  },
  created () {
    if (!this.$q.platform.is.nativeMobile) {
      this.updatesFinished()
      return
    }
    this.open = true
    this.checkAppVersion()
  },
  mounted () {
    this.$bus.on('version:refresh', this.busOnVersionRefresh)
  },
  beforeUnmount () {
    this.$bus.off('version:refresh', this.busOnVersionRefresh)
  }
}
</script>

<style scoped lang="scss">
.system-dialog {
  .q-card {
    max-width: 500px;

    .sys-descr {
      max-width: 400px;
    }
  }
}
</style>
